import {
  FinanceApplicationStatus,
  FinanceProvider,
} from '@upstart/harmony/lib/constants';
import {
  ReportFinanceApplication,
  UpstartApplicationStatus,
} from '@upstart/harmony/lib/legos/financingTypes';
import BackendService from './BackendService';

export default class FinanceApplicationService {
  static get(
    dealId?: string,
    carId?: string,
    status?: FinanceApplicationStatus[],
  ) {
    return BackendService.get(`/financeApplications/${dealId}/${carId}`, {
      params: {
        status,
      },
    });
  }

  static uploadFiles(financeApplicationId?: string, formData?: any) {
    return BackendService.post(
      `/financeApplications/${financeApplicationId}/files`,
      { formData },
      true,
    );
  }

  static getApplicationStatus(financeApplicationId?: string) {
    return BackendService.get(
      `/financeApplications/${financeApplicationId}/application-status`,
    );
  }

  static getApplicationStatuses(
    financeApplicationIds: string[],
  ): Promise<UpstartApplicationStatus[]> {
    return BackendService.post(`/financeApplications/application-statuses`, {
      body: { financeApplicationIds },
    });
  }

  static getApplicationsForDealer(
    dealerId: string,
    provider: FinanceProvider,
    startDate: string,
    endDate: string,
  ) {
    const params = {
      since: startDate,
      until: endDate,
      provider,
    };
    return BackendService.get(`/financeApplications/${dealerId}`, { params });
  }

  static getAllApplications(
    provider: FinanceProvider,
    startDate: string,
    endDate: string,
  ): Promise<ReportFinanceApplication[]> {
    const params = {
      since: startDate,
      until: endDate,
      provider,
    };
    return BackendService.get(`/financeApplications/all`, {
      params,
    });
  }
}
